import { render, staticRenderFns } from "./delivery-notice.vue?vue&type=template&id=37299f2e&"
import script from "./delivery-notice.vue?vue&type=script&lang=js&"
export * from "./delivery-notice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports